import md5 from "@/script/md5";
import { $axios, apiList } from '@/api'

const inMemoryCache = new Map()

export default {
    state: () => ({
        activeTopic: null,
    }),
    mutations: {
        setActiveTopic(state, payload) {
            state.activeTopic = payload
        }
    },
    getters: {
        activeTopicId: state => state.activeTopic
    },
    actions: {
        setActiveTopic({commit}, payload) {
            commit('setActiveTopic', payload)
        },
        triggerLessonViewEvent(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.lesson.triggerViewEvent.method,
                    params: {
                        wsfunction: apiList.lesson.triggerViewEvent.moodle_method,
                        lessonid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getLessonAttempts(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.lesson.getAttempts.method,
                    params: {
                        wsfunction: apiList.lesson.getAttempts.moodle_method,
                        lessonid: payload,
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getLessonUserTimers(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.lesson.getTimer.method,
                    params: {
                        wsfunction: apiList.lesson.getTimer.moodle_method,
                        lessonid: payload,
                        userid: 0
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        processLessonPage(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.lesson.processPage.method,
                    params: {
                        wsfunction: apiList.lesson.processPage.moodle_method,
                        lessonid: payload.id,
                        pageid: payload.page,
                        data: [
                            {
                                name: 'name',
                                'value': 'value'
                            }
                        ]
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        finishLesson(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.lesson.finishAttempt.method,
                    params: {
                        wsfunction: apiList.lesson.finishAttempt.moodle_method,
                        lessonid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getLessonInfo(_, payload) {
            const key = md5(JSON.stringify(payload) + 'lesson-info')
            return new Promise((resolve, reject) => {
                if(inMemoryCache.has(key)) {
                    resolve(inMemoryCache.get(key))
                    return
                }
                $axios({
                    method: apiList.lesson.getLesson.method,
                    params: {
                        wsfunction: apiList.lesson.getLesson.moodle_method,
                        lessonid: payload
                    }
                })
                    .then(resp => {
                        inMemoryCache.set(key, resp.data)
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getLessonPages(_, payload) {
            const key = md5(JSON.stringify(payload) + 'lesson-pages')
            return new Promise((resolve, reject) => {
                if(inMemoryCache.has(key)) {
                    resolve(inMemoryCache.get(key))
                    return
                }
                $axios({
                    method: apiList.lesson.getLessonPages.method,
                    params: {
                        wsfunction: apiList.lesson.getLessonPages.moodle_method,
                        lessonid: payload
                    }
                })
                    .then(resp => {
                        inMemoryCache.set(key, resp.data)
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        getLessonPageContent(_, payload) {
            const key = md5(JSON.stringify(payload))
            return new Promise((resolve, reject) => {
                if(inMemoryCache.has(key)) {
                    resolve(inMemoryCache.get(key))
                    return
                }
                $axios({
                    method: apiList.lesson.getPageContent.method,
                    params: {
                        wsfunction: apiList.lesson.getPageContent.moodle_method,
                        lessonid: payload.lessonid,
                        pageid: payload.pageid
                    }
                })
                    .then(resp => {
                        inMemoryCache.set(key, resp.data)
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        startLessonAttempt(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.lesson.startLessonAttempt.method,
                    params: {
                        wsfunction: apiList.lesson.startLessonAttempt.moodle_method,
                        lessonid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
